import styles from "./writestring.module.css";

type Tprops = {
  strings: string;
  color: string;
};

function Typewriter({ strings, color }: Tprops) {
  return (
    <div className={styles.texttyping} style={{ color: `${color}` }}>
      {strings}
    </div>
  );
}

export default Typewriter;
